var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"fileSelector",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel","focusable":"false"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }